import Swal from "sweetalert2";

const showLoading = () => {
   Swal.fire({
      title: "¡Espere, por Favor!",
      html:  "Mientas se procesa la información",
      allowOutsideClick: false,
      showConfirmButton:false,
      willOpen: () => {
         Swal.showLoading();
      },
   });
}

export default showLoading